import axios from 'axios';
import { createHashHistory } from 'history';
const BASE_URL = process.env.REACT_APP_URL;

const $axios = axios.create({
  baseURL: BASE_URL,
  timeout: 60000,
  withCredentials: true
});

axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

$axios.interceptors.response.use(function(res) {
  if (res && res.status === 200) {
    //cookie失效
    if (res.data && res.data.code === 401) {
      const history = createHashHistory();
      history.push('/login');
    }
    return res.data;
  }
}, error => {
  if (error && error.response) {
    if (error.response.status === 404) {
      const history = createHashHistory();
      history.push('/login');
    }
  }
})

export default $axios;

